import { NoDataLandscape, type INoDataLandscapeProps } from "pro-features/components/NoData/src/NoData";

export interface ITableNoDataProps {
    config?: {
        messageTitle?: INoDataLandscapeProps["title"];
        messageSubtitle?: INoDataLandscapeProps["subtitle"];
    };
}

export const TableNoData = ({ config }: ITableNoDataProps) => (
    <NoDataLandscape
        title={config?.messageTitle || "home.dashboards.widget.table.error1"}
        subtitle={config?.messageSubtitle || ""}
    />
);
